import store from '../..';

export function setFilterOptions(payload) {
  const client = store.getters['account/getCurrentClient'].client_name;
  let tripTypeOptions = [];
  switch (client) {
    case 'bazzbi':
      tripTypeOptions = [
        {
          text: 'QR Code',
          value: 'qr_code',
        },
        {
          text: 'Digital Key',
          value: 'digital_key',
        },
      ];
      break;
    case 'shark':
      tripTypeOptions = [
        'Bluetooth',
        'Select',
        'Select+',
        'Select++',
        'Premium',
      ];
      break;
    case 'avis':
      tripTypeOptions = ['Round Trip', 'One Way'];
      break;
    default:
      tripTypeOptions = ['Round Trip', 'One Way'];
      break;
  }

  const allGroups = store.getters['account/getCurrentClient'].groups;
  const groups = [];
  for (let i = 0; i < allGroups.length; i++) {
    groups.push({
      text: allGroups[i].group_name,
      value: allGroups[i].uuid,
    });
  }

  const versions = [];
  const adScheduleOptions = [];
  payload.data.map((screen) => {
    if (!versions.includes(screen.version) && screen.version !== '') {
      versions.push(screen.version);
    }

    if (
      !adScheduleOptions.includes(screen.ad_schedule)
      && screen.ad_schedule !== null
    ) {
      adScheduleOptions.push(screen.ad_schedule);
    }
  });

  store.commit('filters/setScreensFilterOptions', {
    groups,
    ad_schedules: adScheduleOptions,
    versions,
    session_status: ['Checked In', 'Checked Out', 'Reported'],
    trip_type: tripTypeOptions,
    launch_mode: ['Bluetooth', 'Select', 'Select+', 'Select++', 'Prime'],
    network_status: ['Green', 'Yellow', 'Red'],
  });
}
